/**
 * heroMathStrings.js — Phase HERO-FINAL (decorative editorial typography).
 *
 * ⚠️ COPY-SCRUB EXEMPT — this file is intentionally listed in
 *    frontend/scripts/copy_scrub.py#SKIP_FILES for the same reason as
 *    Methodology.jsx: the strings below are decorative editorial
 *    math-typography rendered onto a `<canvas>` by `HeroSection`, NOT
 *    narrative UI copy. The scrubber would otherwise rewrite
 *    "Monte Carlo", "bifurcation", etc. and destroy the aesthetic. The
 *    numeric fragments ("400 paths", "S≥0.30", "Verhulst 1838",
 *    "p05·p50·p95", "e^(βx)", "∂²f/∂x²") are similarly editorial and
 *    not subject to the Zero-Numbers Rule (which governs narrative UI
 *    text, not visual typography).
 *
 * The list intentionally mixes SDE mechanics, calibration references,
 * distribution notation, cryptography, and papers, at very faint
 * opacities (5–12% and 2–5%). On page load the canvas draws them once
 * — no requestAnimationFrame loop, no re-render on scroll. Redraws on
 * window resize so the layout scales.
 */
export const HERO_MATH_STRINGS = [
    "dXᵢ/dt", "αᵢ·Xᵢ·(Kᵢ-Xᵢ)/Kᵢ", "δᵢ·Xᵢ", "Σⱼ≠ᵢ cᵢⱼ·Xⱼ(t)", "βᵢ·εᵢ(t)",
    "SHA-256", "Ed25519", "p(θ|D)", "structural draw", "∫f(x)dx",
    "σ²=E[(X-μ)²]", "N(μ,σ²)", "S≥0.30", "∂L/∂θ", "Σcᵢⱼ·Xⱼ",
    "h₀=SHA-256(d+t)", "MerkleRoot", "logistic(x)", "Verhulst 1838", "Lotka-Volterra",
    "Bayesian", "GMM", "Sobol", "p05·p50·p95", "κ(f,g)",
    "E[X|θ]", "λ=e^(βx)", "Δt→0", "∇f(x)", "argmin L(θ)",
    "cov(X,Y)", "divergence", "structural draw", "silhouette", "ODE",
    "Quasi-MC", "Rousseeuw 1987", "Ed25519.sign", "∂²f/∂x²", "cᵢⱼ coupling",
];
